module.exports = __webpack_public_path__ + "static/media/spade.ce52cdc3.svg";